import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Col, Row } from 'react-bootstrap'
import { Heading, ContainerBox } from './AdminStyle';
import { LogeButtonSlim, SpinnerWrapper } from '../GeneralStyle'
import ConfirmSendNewContractsModal from "../internal/Modals/ConfirmSendNewContractsModal"
import ApplicationTable from '../Tables/ApplicationTable';
import Parse from 'parse'
import styled from 'styled-components'
import { Form, Select } from 'formsy-react-components';
import moment from 'moment'
import DayPicker, { DateUtils } from 'react-day-picker';
import AnalyticsDayPicker from "./AnalyticsDayPicker"
import { DoubleBounce } from 'better-react-spinkit'
import Fragment from 'react-dot-fragment';

import DatePicker from "react-datepicker";

@inject('userStore', 'adminStore')

@observer
class Analytics extends Component {

  constructor(props) {
    super(props)
    this.state = {
      // startDate: moment(new Date()).subtract(1, 'weeks').toDate(),
      startDate: new Date(new Date().getFullYear()+"/1/1"),
      endDate: new Date(),
      year: new Date().getFullYear(),
      average: 0,
      totalBookings: 0,
      yearlyBookings: 0,
      availableSlots: 0,
      courseData: [],
      companyData: [],
      totalCompanyData: null,
      loading: true,
      lastTask: undefined,
      activeCompanies: 1,
      yearSelectorOptions: this.getYearSelectorOptions()
    }
  }

  componentWillMount() {
    // this.getBookings()
    this.updateData()

  }

  updateData = () => {
    const { analytics } = this.props.adminStore
    this.setState({ loading: true })

    if( !analytics[this.state.year]) {
      return this.props.adminStore.loadAnalytics(this.state.year, data => {
        this.setState({ ...data })
      })
    }

    this.setState({ ...analytics[this.state.year], loading: false })
  }

  updateDate = async data => {
    await this.setState(data)
    this.updateData()

  }

  // updateDates = () => { // ONETIME JOB
  //   const query = new Parse.Query("Booking");
  //   query.each(entry => {
  //     entry.set("bookingDateObj", new Date(entry.get("bookingDate")))
  //     entry.save();
  //   })
  // }

  getYearSelectorOptions = () => {
    const options = []

    for (let i = new Date().getFullYear(); i >= 2017; i--) {
      options.push({label: i, value: i})
    }

    return options

  }

  changeYear = (year) => {
    const from = new Date(year+"/1/1")
    const to = new Date().getFullYear() === year ? new Date() : new Date(year+"/12/31")
    this.updateDate({startDate: from, endDate: to, year})

  }

  sortPercentage = (a, b, order, field) => {
    const a_new = Number(a[field].replace("%", ""))
    const b_new = Number(b[field].replace("%", ""))
    if (order === 'asc') {
      return a_new - b_new;
    } else if (order === 'desc') {
      return b_new - a_new;
    }
  }


  render() {
    const { isAdmin, isLoge } = this.props.userStore;

    if (!isAdmin) {
      //this.props.history.push("/")
    }

    const { startDate, endDate } = this.state
    const { analytics: ana } = this.props.adminStore
    const analytics = ana[this.state.year]

    const startDateString = startDate ? startDate.getFullYear() + "-" + (startDate.getMonth()+1) + "-" + startDate.getDate() : ""
    const startDateStringDisplay = startDate ? startDate.getDate() + "." + (startDate.getMonth()+1) + "." + startDate.getFullYear(): ""
    const endDateString = endDate ? endDate.getFullYear() + "-" + (endDate.getMonth()+1) + "-" + endDate.getDate() : ""
    const endDateStringDisplay = endDate ? endDate.getDate() + "." + (endDate.getMonth()+1) + "." + endDate.getFullYear(): ""
    const golfCourseFilename = `golfclub_statistiken_${startDateString}_${endDateString}.csv`
    const companyFilename = `firmen_statistiken_${startDateString}_${endDateString}.csv`

    return (
      <div>
      {(isAdmin || isLoge) ?
          <div>
            <Row style={{maxWidth: 1200, margin: "0 auto"}}>
              {/* <Col xs={12} md={4} lg={4} className={'mobile-no-padding'}></Col> */}
              {/* <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox style={{paddingBottom: 25, textAlign: "left", marginBottom: 0, color: "black"}}>
                  <Line>
                    <Heading>Datumsauswahl</Heading>
                    <DateText>
                      {startDateStringDisplay} <span style={{fontSize: "0.8em"}}>bis</span> {endDateStringDisplay}
                    </DateText>
                  </Line>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 5 }}></div>
                  <Row>
                    <Col md={12}>
                      <AnalyticsDayPicker handleChange={value => this.updateDate(value)} values={{from: this.state.startDate, to: this.state.endDate}}/>
                    </Col>
                  </Row>
                </ContainerBox>
              </Col> */}

              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox style={{padding: 25, textAlign: "right", marginBottom: -15, color: "black", display: 'flex', justifyContent: 'space-between'}}>
                  <Heading>Jahresauswahl</Heading>
                  <Form style={{width: '200px', display: 'inline-block'}}>

                  <Select
        						name="year"
                    label={ false }
        						value={ new Date().getFullYear() }
        						options={ this.state.yearSelectorOptions }
        						onChange={(e, val) => this.changeYear(val)}
                    style={{marginTop: 15}}
        					/>
                  </Form>

                </ContainerBox>
              </Col>

              { (analytics && !analytics.loading ) ?
              <div>
              <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                <ContainerBox style={{paddingBottom: 25, textAlign: "center", marginBottom: 0}}>
                  <Heading style={{padding: 0}}>Gesamt</Heading>
                  <div style={{ marginLeft: 15, marginRight: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "50%", marginBottom: 10, display: "inline-block" }}></div>

                  <NumberDisplay>{ analytics.totalBookings }</NumberDisplay>
                  <Information>Buchungen im Zeitraum</Information>

                </ContainerBox>
              </Col>
              <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                <ContainerBox style={{paddingBottom: 25, textAlign: "center", marginBottom: 0}}>
                  <Heading style={{padding: 0}}>Durchschnittlich</Heading>
                  <div style={{ marginLeft: 15, marginRight: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "50%", marginBottom: 10, display: "inline-block" }}></div>

                  <NumberDisplay>{ Number( (analytics.totalBookings - analytics.graveyard_bookings) / analytics.activeCompanies - 1).toFixed(0) }</NumberDisplay>
                  <Information>Buchungen pro Firma</Information>

                </ContainerBox>
              </Col>
              {/* <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                <ContainerBox style={{paddingBottom: 25, textAlign: "center", marginBottom: 0}}>
                  <Heading style={{padding: 0}}>Durchschnittlich</Heading>
                  <div style={{ marginLeft: 15, marginRight: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "50%", marginBottom: 10, display: "inline-block" }}></div>

                  <NumberDisplay>{ this.state.average }</NumberDisplay>
                  <Information>Buchungen in 30 Tagen</Information>

                </ContainerBox>
              </Col> */}
              <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                <ContainerBox style={{paddingBottom: 25, textAlign: "center", marginBottom: 0}}>
                  <Heading style={{padding: 0}}>Auslastung</Heading>
                  <div style={{ marginLeft: 15, marginRight: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "50%", marginBottom: 10, display: "inline-block" }}></div>

                  <NumberDisplay>{ analytics.availableSlots ? (analytics.totalBookings / analytics.availableSlots * 100).toFixed(0) : 0}%</NumberDisplay>
                  <Information>({ analytics.totalBookings } / { analytics.availableSlots })</Information>

                </ContainerBox>
              </Col>

              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >

              <ContainerBox style={{paddingBottom: 25, textAlign: "center", marginBottom: 0}}>
                <Row style={{maxWidth: 1200, margin: "0 auto"}}>
                  <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                      <Heading style={{padding: 0}}>Info Anfragen</Heading>
                      <div style={{ marginLeft: 15, marginRight: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "50%", marginBottom: 10, display: "inline-block" }}></div>

                      <NumberDisplay>{analytics.leads.info}</NumberDisplay>
                  </Col>
                  <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                      <Heading style={{padding: 0}}>Bewerbungen</Heading>
                      <div style={{ marginLeft: 15, marginRight: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "50%", marginBottom: 10, display: "inline-block" }}></div>

                      <NumberDisplay>{analytics.leads.application}</NumberDisplay>
                      <Information style={{opacity: 0.7}}>(= {Math.ceil( analytics.leads.application / analytics.leads.info * 100 )} %)</Information>
                  </Col>
                  <Col xs={12} md={4} lg={4} className={'mobile-no-padding'} >
                      <Heading style={{padding: 0}}>Mitglieder</Heading>
                      <div style={{ marginLeft: 15, marginRight: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "50%", marginBottom: 10, display: "inline-block" }}></div>

                      <NumberDisplay>{analytics.leads.member}</NumberDisplay>
                      <Information style={{opacity: 0.7}}>(= {Math.ceil( analytics.leads.member / analytics.leads.info * 100 )} % der Info Anfragen)</Information>
                      <Information style={{opacity: 0.7}}>(= {Math.ceil( analytics.leads.member / analytics.leads.application * 100 )} % der Bewerbungen)</Information>
                  </Col>
                </Row>
              </ContainerBox>
              </Col>

              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox style={{paddingBottom: 25, marginBottom: 0}}>

                  <Heading>Golfclubs</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table'}>
                    <TableColorWrapper color="#dab77736">
                    <BootstrapTable data={ analytics.courseData } borderless hover pagination search options={{ defaultSortName: 'total', defaultSortOrder: 'desc' }} exportCSV csvFileName={golfCourseFilename}>
                      <TableHeaderColumn dataField="name" isKey dataSort>Name</TableHeaderColumn>
                      <TableHeaderColumn dataField="dailySlots" dataSort>Tagesspielrechte</TableHeaderColumn>
                      <TableHeaderColumn dataField="totalSlots" dataSort>Gesamt SR</TableHeaderColumn>
                      <TableHeaderColumn dataField="total" dataSort>gespielte Runden</TableHeaderColumn>
                      <TableHeaderColumn dataField="workload" dataSort>Gesamt Auslastung</TableHeaderColumn>
                      <TableHeaderColumn dataField="average" dataSort>30 Tage Durchschnitt</TableHeaderColumn>


                      {/* <TableHeaderColumn dataField="average" dataSort>30 Tage Durchschnitt</TableHeaderColumn>
                      <TableHeaderColumn dataField="total" dataSort>Gesamt</TableHeaderColumn>
                      <TableHeaderColumn dataField="workload" dataSort>Auslastung</TableHeaderColumn> */}
                    </BootstrapTable>
                    </TableColorWrapper>
                  </div>

                </ContainerBox>
              </Col>

              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox style={{paddingBottom: 25, marginBottom: 0}}>

                  <Heading>Golfclubs pro Monat</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table'}>
                    <TableColorWrapper color="#6892c752">
                    <BootstrapTable data={ analytics.courseMonthlyData } borderless hover pagination search options={{ defaultSortName: 'name', defaultSortOrder: 'desc' }} exportCSV csvFileName={golfCourseFilename}>
                      <TableHeaderColumn dataField="name" isKey dataSort>Name</TableHeaderColumn>
                      <TableHeaderColumn dataField="0" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "0")}>Januar</TableHeaderColumn>
                      <TableHeaderColumn dataField="1" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "1")}>Februar</TableHeaderColumn>
                      <TableHeaderColumn dataField="2" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "2")}>März</TableHeaderColumn>
                      <TableHeaderColumn dataField="3" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "3")}>April</TableHeaderColumn>
                      <TableHeaderColumn dataField="4" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "4")}>Mai</TableHeaderColumn>
                      <TableHeaderColumn dataField="5" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "5")}>Juni</TableHeaderColumn>
                      <TableHeaderColumn dataField="6" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "6")}>Juli</TableHeaderColumn>
                      <TableHeaderColumn dataField="7" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "7")}>August</TableHeaderColumn>
                      <TableHeaderColumn dataField="8" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "8")}>September</TableHeaderColumn>
                      <TableHeaderColumn dataField="9" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "9")}>Oktober</TableHeaderColumn>
                      <TableHeaderColumn dataField="10" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "10")}>November</TableHeaderColumn>
                      <TableHeaderColumn dataField="11" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "11")}>Dezember</TableHeaderColumn>
                    </BootstrapTable>
                    </TableColorWrapper>
                  </div>

                </ContainerBox>
              </Col>

              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox style={{paddingBottom: 25}}>

                  <Heading>Firmen</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table'}>
                    <BootstrapTable data={ new Array(analytics.totalCompanyData) } borderless>
                      <TableHeaderColumn dataField="name" isKey>Name</TableHeaderColumn>
                      <TableHeaderColumn dataField="total">Gesamt</TableHeaderColumn>
                      <TableHeaderColumn dataField="normal">Normal</TableHeaderColumn>
                      <TableHeaderColumn dataField="remaining">Restplatz</TableHeaderColumn>
                      <TableHeaderColumn dataField="remaining_coins">verfügbare Credits</TableHeaderColumn>
                      <TableHeaderColumn dataField="used_coins">genutzt Credits</TableHeaderColumn>
                      <TableHeaderColumn dataField="workload">Auslastung</TableHeaderColumn>
                    </BootstrapTable>

                    <div style={{paddingBottom: 25}}></div>

                    <TableColorWrapper color="#59a95c36">
                    <BootstrapTable data={ analytics.companyData } borderless hover pagination search options={{ defaultSortName: 'total', defaultSortOrder: 'desc' }} exportCSV csvFileName={companyFilename}>
                      <TableHeaderColumn dataField="name" isKey>Name</TableHeaderColumn>
                      <TableHeaderColumn dataField="total" dataSort>Gesamt</TableHeaderColumn>
                      <TableHeaderColumn dataField="normal" dataSort>Normal</TableHeaderColumn>
                      <TableHeaderColumn dataField="remaining" dataSort>Restplatz</TableHeaderColumn>
                      <TableHeaderColumn dataField="remaining_coins" dataSort>verfügbare Credits</TableHeaderColumn>
                      <TableHeaderColumn dataField="used_coins" dataSort>genutzt Credits</TableHeaderColumn>
                      <TableHeaderColumn dataField="workload" dataSort sortFunc={(a, b, order) => this.sortPercentage(a, b, order, "workload")}>Auslastung</TableHeaderColumn>
                    </BootstrapTable>
                    </TableColorWrapper>
                    {/* <small style={{display: "block", paddingTop: 10}}>* 30 Tages Durschnitt</small> */}
                  </div>

                </ContainerBox>
              </Col>

              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox style={{paddingBottom: 25, marginBottom: 75}}>

                  <Heading>Firmen nach Golfclub</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table min_col_width_table'}>
                    {/* <BootstrapTable data={ new Array(this.state.totalCompanyData) } borderless>
                      <TableHeaderColumn dataField="name" isKey>Name</TableHeaderColumn>

                      <TableHeaderColumn dataField="total">Gesamt</TableHeaderColumn>
                    </BootstrapTable> */}

                    <div style={{paddingBottom: 25}}></div>

                    <FixFirstColumnWrapper color="#dab77736">
                      <TableColorWrapper color="#dab77736">
                        <BootstrapTable data={ analytics.companyByCourseData } borderless hover pagination options={{ defaultSortName: 'name', defaultSortOrder: 'desc' }}>
                          <TableHeaderColumn dataField="name" isKey dataSort>Name</TableHeaderColumn>
                          { analytics.courseData.map(course =>
                            <TableHeaderColumn style={{ width: 100 }} dataField={course.id} key={course.id} dataSort>{course.name}</TableHeaderColumn>
                          )}

                        </BootstrapTable>
                      </TableColorWrapper>
                    </FixFirstColumnWrapper>
                    {/* <small style={{display: "block", paddingTop: 10}}>* 30 Tages Durschnitt</small> */}
                  </div>

                </ContainerBox>
              </Col>

              </div>
              :
              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >

                <SpinnerWrapper>
                  <DoubleBounce color={"#DAB777"} size={35} />
                </SpinnerWrapper>

              </Col>
              }
            </Row>
          </div>
          : ''}

      </div>
    )
  }
}

const NumberDisplay = styled.div `
  font-size: 50px;
  color: #212D3D;
	display: block;
	font-family: "Lora";
`
const Information = styled.div `
  font-size: 18px;
  color: #212D3D;
	display: block;
	font-family: "Catamaran";
`

const Line = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 25px;
`

const DateText = styled.div `
  font-size: 18px;
  color: #212D3D;
	display: inline-block;
	font-family: "Catamaran";
`

const TableColorWrapper = styled.div `
  tbody tr:nth-child(2n-1) {
    background-color: ${props => props.color};
  }
`

const FixFirstColumnWrapper = styled.div `
  ${'' /* tr td:first-child {
    position: absolute;
    text-align: left;
    background: white;
    margin-top: -1px;
    border-right: 1px solid #ddd !important;
  }

  tr:nth-child(2n-1) td:first-child {
    background-color: ${props => props.color};
  } */}
`

Analytics.propTypes = {
  golfCourseStore: MobxPropTypes.observableObject
}

export default Analytics



// WEBPACK FOOTER //
// /src/components/admin/Analytics.js